import { all, put, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { anonClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
} from '../../shared-components/Notifications';

export function* confirmExtendSubscription({ data }) {
  try {
    const res = yield retry(4, 500, anonClient?.Subscription?.extend, {
      body: data,
    });
    yield put({
      type: resolve(types.CONFIRM_EXTEND_SUBSCRIPTION),
      payload: res.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Your subscription has been extended for another 30 days',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types.CONFIRM_EXTEND_SUBSCRIPTION),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types.CONFIRM_EXTEND_SUBSCRIPTION),
        ),
      }),
    ]);
  }
}
